import Sunny16BaseService from '@/services/Sunny16BaseService'

import type {
  CartStorefrontDto,
  CheckoutDetailsDto
} from '@VelocitySquared/sunny16-commerce-dataobjects/storefront'

class Sunny16CommerceCheckoutService extends Sunny16BaseService {
  constructor() {
    super(import.meta.env.VITE_SUNNY_16_CHECKOUT_API_BASE_URL, 'Sunny16CommerceCheckoutService')
  }
  async initStripePaymentElement(orderId: string): Promise<CartStorefrontDto> {
    try {
      const response = await this.axiosInstance.get(`/stripe-payment-element/${orderId}`)
      return response.data
    } catch (error) {
      throw error
    }
  }
  async completeCustomerServiceOrder(
    cartId: string,
    checkoutDetails: CheckoutDetailsDto
  ): Promise<CartStorefrontDto> {
    try {
      const response = await this.axiosInstance.post(`/customerservice/${cartId}`, checkoutDetails)
      return response.data
    } catch (error) {
      throw error
    }
  }
  /**
   * Complete a $0 order without going through Stripe payment confirmation.
   * Called when the order total is zero (e.g. promo codes that fully discount, or a
   * naturally-free session bundle). The endpoint takes no body — the order's customer
   * fields must already be persisted via a prior `UpsertOrder` call. Server validates
   * `Total == 0` and required field presence, then writes a `NoCharge` `OrderTransaction`
   * and returns the finalized cart. Idempotent on already-completed orders.
   */
  async completeFreeOrder(orderId: string): Promise<CartStorefrontDto> {
    try {
      const response = await this.axiosInstance.post(`/no-charge/${orderId}`)
      return response.data
    } catch (error) {
      throw error
    }
  }
}

export default Sunny16CommerceCheckoutService
